module.exports = __webpack_public_path__ + "assets/img/Reduce-los-costes-en-producto-7.2393abc5.png";